import Button from '../../../../components/ui/Button';
import Icon from '../../../../components/AppIcon';

const ErrorState = ({ error, onBack }) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
    <div className="text-center max-w-md">
      <Icon name="AlertCircle" size={64} className="text-red-500 mx-auto mb-4" />
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Oops! Something went wrong</h2>
      <p className="text-gray-600 mb-6">{error || 'Order not found'}</p>
      <Button onClick={onBack} className="bg-blue-600 hover:bg-blue-700 text-white">
        Back to Orders
      </Button>
    </div>
  </div>
);

export default ErrorState;